const JsSlider = {
	init () {

		/*
		* Card Slider
		*/

		/*              __
		               / _)
		        .-^^^-/ /
		    __/       /
		    <__.|_|-|_|

		    The Emagine Dinosaur says to lazyload all images, or fear extinction
		*/

		// Card Slider - used to slide images in card top
		if ( $('.c-card-slider').length ) {

			// Calculate whether or not card images should have portrait override class
			// first loop through all sliders on page
			$('.c-card-slider').each( function(i, v) {

				// then loop through the slides in that slider
				$(v).find('.c-slide').each( function(key, value) {
					// Find actual image
					let targetImage = $(value).find('img');

					// Create test image, to compare dimensions
					let testImage = new Image();
					testImage.src = targetImage.attr('src');

					let imgWidth = testImage.naturalWidth;
					let imgHeight = testImage.naturalHeight;

					if ( imgHeight !== 0 ) {
						if ( imgHeight >= imgWidth ) {
							$(value).find('img').addClass('portrait');
						}
					}
				});
			});

			// Init Slider
			$('.c-card-slider').slick({
				// Lazyload all the things
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: '<div class="slick-prev" aria-hidden="true"><div>',
				nextArrow: '<div class="slick-next" aria-hidden="true"><div>',
				dots: false,
				draggable: true,
				pauseOnFocus: false,
				pauseOnHover: false,
				fade: true,
				infinite: true,
				cssEase: 'linear'
			});
		}

		// Full card slider - used to slide full card
		$('.c-full-card-slider').slick({
			// Lazyload all the things
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			draggable: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			fade: true,
			infinite: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1920,
					settings: {
						adaptiveHeight: false
					}
				},
				{
					breakpoint: 639,
					settings: {
						adaptiveHeight: true
					}
				}
			]
		});

    // $('.c-full-card-slider--with-arrows').slick({
		// 	// Lazyload all the things
		// 	lazyLoad: 'ondemand',
		// 	slidesToShow: 1,
		// 	slidesToScroll: 1,
    //   arrows: true,
    //   prevArrow: '<div class="slick-prev" aria-hidden="true"><div>',
    //   nextArrow: '<div class="slick-next" aria-hidden="true"><div>',
		// 	dots: true,
		// 	draggable: true,
		// 	pauseOnFocus: false,
		// 	pauseOnHover: false,
		// 	fade: true,
		// 	infinite: true,
		// 	cssEase: 'linear',
		// 	autoplay: true,
		// 	autoplaySpeed: 3000,
		// 	responsive: [
		// 		{
		// 			breakpoint: 1920,
		// 			settings: {
		// 				adaptiveHeight: false
		// 			}
		// 		},
		// 		{
		// 			breakpoint: 639,
		// 			settings: {
		// 				adaptiveHeight: true
		// 			}
		// 		}
		// 	]
		// });


		// Hero Slider - used to make big slidey images
		// if ( $('.c-hero-slider').length ) {
		// 	$('.c-hero-slider').slick({
		// 		// Lazyload all the things
		// 		lazyLoad: 'ondemand',
		// 		slidesToShow: 1,
		// 		slidesToScroll: 1,
		// 		arrows: false,
		// 		dots: false,
		// 		draggable: true,
		// 		pauseOnFocus: false,
		// 		pauseOnHover: true,
		// 		fade: true,
		// 		infinite: true,
		// 		cssEase: 'linear',
		// 		autoplay: true,
		// 		autoplaySpeed: 3000,
		// 	});
		// }

    if ( $('.c-hero-slider').length ) {
			$('.c-hero-slider').slick({
				// Lazyload all the things
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
        arrows: true,
				prevArrow: '<div class="slick-prev" aria-hidden="true"><div>',
				nextArrow: '<div class="slick-next" aria-hidden="true"><div>',
				dots: false,
				draggable: true,
				pauseOnFocus: false,
				pauseOnHover: true,
				fade: true,
				infinite: true,
				cssEase: 'linear',
				autoplay: true,
				autoplaySpeed: 3000,
			});
		}
	}
};

export default JsSlider;



// WEBPACK FOOTER //
// ./src/components/03-ui/slider/slider.js